import { render, staticRenderFns } from "./TextAreaEditor.vue?vue&type=template&id=cb07e624"
import script from "./TextAreaEditor.vue?vue&type=script&lang=js"
export * from "./TextAreaEditor.vue?vue&type=script&lang=js"
import style0 from "./TextAreaEditor.vue?vue&type=style&index=0&id=cb07e624&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports